import { useState } from "react";
import { cn } from "../../lib/utils";
import { Sidebar } from "./Sidebar";
import { Footer } from "./Footer";

interface MainLayoutProps {
  children: React.ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen overflow-hidden">
      <Sidebar isCollapsed={isCollapsed} onToggleCollapse={() => setIsCollapsed(!isCollapsed)} />

      {/* Main Content + Footer */}
      <div className={cn("flex-1 flex flex-col min-w-0", isCollapsed ? "pl-16" : "pl-56")}>
        <main className="flex-1 bg-[#F8F8FA] overflow-auto">
          <div className="px-8 py-8 max-w-full">{children}</div>
        </main>
        <Footer />
      </div>
    </div>
  );
};
